var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoCheckboxFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(0 0.438965)",
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 2.43896H3.33333C2.6 2.43896 2 3.03896 2 3.7723V13.1056C2 13.839 2.6 14.439 3.33333 14.439H12.6667C13.4 14.439 14 13.839 14 13.1056V3.7723C14 3.03896 13.4 2.43896 12.6667 2.43896ZM7.14 11.299C6.88 11.559 6.46 11.559 6.2 11.299L3.80667 8.90563C3.54667 8.64563 3.54667 8.22563 3.80667 7.96563C4.06667 7.70563 4.48667 7.70563 4.74667 7.96563L6.66667 9.88563L11.2533 5.29896C11.5133 5.03896 11.9333 5.03896 12.1933 5.29896C12.4533 5.55896 12.4533 5.97896 12.1933 6.23896L7.14 11.299Z",
    fill: "#1648D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCheckboxFilled);
export default __webpack_public_path__ + "static/media/ico-checkbox-filled.91ffdf80b5c82548e9e626a85b1330a2.svg";
export { ForwardRef as ReactComponent };